import PlayIcon from "@/components/icons/play";

const PlayButton = () => (
  <div className="flex items-center justify-center bg-black/40 hover:bg-black/60 hover:cursor-pointer size-12 rounded-full top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 absolute">
    <PlayIcon className="size-6 text-brand-blue-600" fill="white" stroke="white" />
  </div>
);

export default PlayButton;
